import React, { useState } from 'react';
import SGMSClient from '../../../js/SGMSClient';
import { store } from '../../../stores/store';
import './ConnectForm.css';


const ConnectForm = ({onFormSuccess}) => {


  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");

  const [error, setError] = useState(false);


  const handleSubmit = (e) => {
    e.preventDefault()
    let { Universe, App } = window.CONFIG.vertexConfig

    SGMSClient.logout()
    .then(() => SGMSClient.login(Universe, App, login, password))
    .then(() => onFormSuccess())
    .catch(() => setError(true))
  }

  return (
    <div className="ConnectForm">
      <form onSubmit={handleSubmit}>
        <p>
          <label htmlFor="login_email">{store.t("form_email")}</label>
          <input
          type="email"
          id="login_email"
          value={login}
          onChange={e => setLogin(e.target.value)} />
        </p>
        <p>
          <label htmlFor="login_password">{store.t("form_password")}</label>
          <input
          type="password"
          id="login_password"
          value={password}
          onChange={e=>setPassword(e.target.value)} />
        </p>

        {error && <p className="error">{store.t("connection_error")}</p>}

        <button>{store.t("button_connect")}</button>
      </form>
    </div>
  );
};

export default ConnectForm;
